import React from 'react'
import { Script } from 'gatsby'

const SignUpFormCustom = ({code, blockId}) => (
	<aside id={blockId} className="max-w-screen-xl mx-auto py-12 md:py-20">
		<div className={`klaviyo-form-${code}`}></div>
		<Script src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=TvAzQX" />
	</aside>
)

export default SignUpFormCustom
